import api from './axios';

export const loginApi = (email, password) =>
  api.post('/auth/login', { email, password });

export const verify2FAApi = (pre_auth_token, code) =>
  api.post('/auth/verify-2fa', { pre_auth_token, code });

export const registerApi = (formData) =>
  api.post('/auth/register', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const refreshTokenApi = (refresh_token) =>
  api.post('/auth/refresh', { refresh_token });

export const logoutApi = () => {
  const refresh_token = localStorage.getItem('refresh_token');
  return api.post('/auth/logout', { refresh_token });
};

export const resetPasswordApi = (email) =>
  api.post('/auth/reset-password', { email });

export const checkEmailApi = (email) =>
  api.post('/auth/check-email', { email });

export const setup2FAApi = () =>
  api.post('/users/me/setup-2fa');

export const enable2FAApi = (code) =>
  api.post('/users/me/enable-2fa', { code });

export const disable2FAApi = (code) =>
  api.post('/users/me/disable-2fa', { code });